import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { LoginNavbar } from "./Components/Common/Navbar/LoginNavbar";
import { useAuth } from "../src/Context/AuthContext";
import Loader from "./Components/Common/Loader/Loader";

import "react-toastify/dist/ReactToastify.css";
// import Login from "./Components/Login/Login";

const Home = React.lazy(() =>
  import("./Components/LandingPage/Home").then((module) => ({
    default: module.Home,
  })),
);
const About = React.lazy(() =>
  import("./Components/LandingPage/About").then((module) => ({
    default: module.About,
  })),
);
const Blog = React.lazy(() =>
  import("./Components/LandingPage/Blog").then((module) => ({
    default: module.Blog,
  })),
);
const MainLayout = React.lazy(() =>
  import("./MainLayout").then((module) => ({ default: module.MainLayout })),
);
// const SocialLogin = React.lazy(() => import("./Components/LandingPage/SocialLogin")); // Already default export or named? checking imports.
// SocialLogin was imported as default: import SocialLogin from ...
// Wait, previous import was: import SocialLogin from "./Components/LandingPage/SocialLogin";
// So it is default export.

const LazySocialLogin = React.lazy(
  () => import("./Components/LandingPage/SocialLogin"),
);

const App = () => {
  // `bootstrapping` is true until the refresh cookie has been exchanged for an
  // access token. Rendering the logged-out tree during that window would flash
  // the marketing site at an authenticated user on every reload.
  const { isLogin, bootstrapping } = useAuth();

  if (bootstrapping) {
    return <Loader />;
  }

  return (
    <Router
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }}
    >
      <ToastContainer />
      {isLogin ? (
        <Suspense fallback={<Loader />}>
          <MainLayout />
        </Suspense>
      ) : (
        <>
          <LoginNavbar />
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              {/* <Route path="/login" element={<Login />} /> */}
              <Route path="/socialLogin" element={<LazySocialLogin />} />
            </Routes>
          </Suspense>
        </>
      )}
    </Router>
  );
};

export default App;
